import React, { Component } from 'react';
import { FormFieldFunctions } from '../../interfaces/FormField/FormField';
import Snapshot from '../../interfaces/Snapshot/Snapshot';
import FormFieldHiddenProps from './FormFieldHidden.props';
import FormFieldHiddenState from './FormFieldHidden.state';

export default class FormFieldHidden extends Component<FormFieldHiddenProps, FormFieldHiddenState> implements FormFieldFunctions {
    constructor(props: FormFieldHiddenProps) {
        super(props);
        this.state = { 
            value: this.props.value || ''
        };
    }

    updateAndNotify = () => {
        this.setState({
            value: this.props.value || ''
        });
    }

    getSnapshotBeforeUpdate(prevProps: FormFieldHiddenProps): Snapshot {
        return { notifyRequired: prevProps.value !== this.props.value };
    }

    componentDidUpdate(prevProps: FormFieldHiddenProps, prevState: FormFieldHiddenState, snapshot: Snapshot) {
        if (snapshot.notifyRequired) {
            this.updateAndNotify();
        }
    }
    
    isValid(): boolean {
        return true;
    }

    toggleValidationError(show: boolean) {
        return;
    }

    getValue() {
        return this.state.value;
    }

    render(): React.ReactNode {
        return (
            <input type="hidden" 
                id={this.props.id} 
                name={this.props.id} 
                value={this.state.value} 
                data-testid="FormFieldHidden"/>
        );
    }
}
